/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDay } from '../../models/meet-day';

export interface GetMeetDay$Params {
  id: string;
}

export function getMeetDay(http: HttpClient, rootUrl: string, params: GetMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
  const rb = new RequestBuilder(rootUrl, getMeetDay.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDay>;
    })
  );
}

getMeetDay.PATH = '/meetday/{id}';
